// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__1n8_z","wrap":"Layout_wrap__LxtDZ","content":"Layout_content__LtaQR"};